import { render, staticRenderFns } from "./PricesReindex.vue?vue&type=template&id=1a60e20a"
import script from "./PricesReindex.vue?vue&type=script&lang=js"
export * from "./PricesReindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports